export const resolveShortQrUrl = (baseUrl, qr) => {
  // 직접 연결 QR에 단축 URL을 노출하면 의도하지 않은 통계 수집이 발생할 수 있다.
  if (!qr || qr.trackingEnabled === false) return '';
  if (typeof qr.shortCode !== 'string' || !qr.shortCode.trim()) return '';
  if (typeof baseUrl !== 'string' || !baseUrl.trim()) return '';

  const normalizedBaseUrl = baseUrl.trim().replace(/\/+$/, '');
  return `${normalizedBaseUrl}/qr/${qr.shortCode}`;
};

export const resolveQrContentUrl = (baseUrl, qr) => {
  if (qr?.trackingEnabled === false) {
    return typeof qr.targetUrl === 'string' && qr.targetUrl.trim() ? qr.targetUrl : '';
  }

  return resolveShortQrUrl(baseUrl, qr);
};

// 소유 QR(ownerType 이 있음)은 소유한 서비스가 관리한다. 이 화면에서는 조회만 한다(inapi도 변경을 400으로 거부).
// FILE_BUNDLE = Studio 상담 파일 묶음(counsel-api), CENTRAL_SCENARIO_LINK = 시나리오 배포 숏링크(crm-api).
export const isOwnedQr = (qr) => Boolean(qr?.ownerType);
export const FILE_BUNDLE_LOCK_TOOLTIP = 'Studio 설정 > 상담 파일 관리 > 묶음 관리에서 관리합니다';

const OWNED_QR_META = {
  FILE_BUNDLE: {
    label: '상담 파일 묶음',
    tooltip: FILE_BUNDLE_LOCK_TOOLTIP,
    notice: 'Studio 상담 파일 묶음에서 관리하는 QR코드입니다. 이 화면에서는 조회만 할 수 있으며, 변경은 Studio 설정 > 상담 파일 관리 > 묶음 관리에서 합니다.'
  },
  CENTRAL_SCENARIO_LINK: {
    label: '시나리오 배포 링크',
    tooltip: 'CRM 관리 > 시나리오 배포 > 링크에서 관리합니다',
    notice: '시나리오 배포 알림톡의 병원별 숏링크 QR코드입니다. 이 화면에서는 조회만 할 수 있으며, 변경은 CRM 관리 > 시나리오 배포 > 링크에서 합니다.'
  }
};
const OTHER_OWNED_QR_META = {
  label: '다른 서비스 소유',
  tooltip: '다른 서비스에서 관리하는 QR코드라 이 화면에서는 바꿀 수 없습니다',
  notice: '다른 서비스에서 관리하는 QR코드입니다. 이 화면에서는 조회만 할 수 있습니다.'
};
// 소유 QR 종류별 표시(태그·잠금 안내). isOwnedQr 일 때만 쓴다.
export const ownedQrMeta = (qr) => OWNED_QR_META[qr?.ownerType] || OTHER_OWNED_QR_META;
